// Must run before the App module graph evaluates: App creates the redux store
// (and starts redux-persist rehydration) at module scope.
import './common/legacyStorageSweep'
import { createRoot } from 'react-dom/client'

import App from './App'
import { initCrossTabSessionSync } from './common/session'

initCrossTabSessionSync()

createRoot(document.getElementById('root')!).render(<App />)
